import apiConfig from "../ApiConfig";

// Answers a natural-language question using the AI agent's project/framework
// knowledge base. Returns { answer, sources }.
export const askAiAgentApi = async (question) => {
  const res = await apiConfig.post("/api/ai-agent/chat/", { question });
  return res.data;
};
